import * as React from "react";
import moment from "moment";
import { Formik, Field, FormikErrors } from "formik";
import FormikDob from "../../../components/form/FormikDob";
import * as Yup from "yup";
import { ParticipantDobVerfication } from "../types";

interface OwnProps {
  participantType: string;
  validateDateOfBirth: (
    params: ParticipantDobVerfication,
    onError: (error: FormikErrors<{ dateOfBirth: null }>) => void
  ) => void;
  errorMessage: string;
}

interface OwnState {
  submitDisabled: boolean;
  dateOfBirth: string;
}

class ValidateDob extends React.PureComponent<OwnProps, OwnState> {
  public constructor(props: OwnProps) {
    super(props);

    this.state = {
      submitDisabled: false,
      dateOfBirth: ""
    };
  }

  public render() {
    return (
      <Formik
        initialValues={{ dateOfBirth: this.state.dateOfBirth }}
        onSubmit={async (values, form) => {
          this.props.validateDateOfBirth(values, form.setErrors);
        }}
        validationSchema={Yup.object().shape({
          dateOfBirth: Yup.string().test("date", "Please enter a valid date of birth", val =>
            moment(val).isValid()
          )
        })}
      >
        {props => {
          const { dirty, initialTouched, isSubmitting, isValid, handleSubmit } = props;

          return (
            <form onSubmit={handleSubmit}>
              <div className="prompt">
                <div className="small">For security, please enter</div>
                <div className="mt-5 bold mb-25">
                  {this.props.participantType === "patient"
                    ? "your date of birth"
                    : "the patients' date of birth"}
                </div>

                <div className="mb-10 small">
                  <span className="gray">Example:</span> 01/25/1970
                </div>

                <div>
                  <Field name="dateOfBirth" component={FormikDob} />

                  {this.props.errorMessage && this.props.errorMessage != "Bad Request" && (
                    <div className="formik-error center mt-10">{this.props.errorMessage}</div>
                  )}

                  <button
                    type="submit"
                    className={
                      "full-width mt-25 " +
                      (props.values.dateOfBirth && dirty && isValid ? "highlight" : "")
                    }
                    disabled={
                      !props.values.dateOfBirth ||
                      !initialTouched ||
                      !dirty ||
                      !isValid ||
                      isSubmitting
                    }
                  >
                    Continue
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    );
  }
}

export default ValidateDob;
